import type {
  ActivityType,
  GlucoseEvent,
} from "@tandemdiabetes/sugarmate-api-react-client"
import type { Reading } from "src/types"

type RequiredProperties = "started_at" | ActivityType.Glucose | "source"

export function glucoseEventToReading(
  glucoseEvent: Pick<GlucoseEvent, RequiredProperties>,
): Reading {
  return {
    startedAt: glucoseEvent.started_at,
    glucose: glucoseEvent.glucose,
    source: glucoseEvent.source,
    readingType: "event",
  }
}
